module.exports = __webpack_public_path__ + "static/img/al6.a80c175.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/al6.jpg
// module id = szsk
// module chunks = 1